import { useTranslation } from 'react-i18next';
import { Badge } from '@shared/components/ui/badge';
import { Avatar, AvatarFallback, AvatarImage } from '@shared/components/ui/shadcn/avatar';
import type { OrderItem } from '../../hooks/useImportOrder';

export interface ImportOrderLineItemProps {
  item: OrderItem;
  quantity: number;
  'data-testid'?: string;
}

export const ImportOrderLineItem = ({ item, quantity, 'data-testid': testId }: ImportOrderLineItemProps) => {
  const { t } = useTranslation('shopsModule');
  const fallback = item.acronym?.trim() || (item.name ? item.name.slice(0, 3).toUpperCase() : '?');

  return (
    <div className="flex items-start gap-3 min-w-0" data-testid={testId}>
      <Avatar className="h-10 w-10 shrink-0 rounded-md border border-border">
        <AvatarImage src={item.image || undefined} alt="" />
        <AvatarFallback className="rounded-md bg-card-border text-[11px] font-semibold leading-none text-foreground">
          {fallback}
        </AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1 pt-0.5">
        <p className="text-sm font-medium text-foreground leading-snug line-clamp-3">
          {item.name?.trim() || t('modals.importOrder.unnamedProduct')}
        </p>
        {item.sku ? (
          <p className="mt-1 text-xs text-subtext">
            <span className="mr-1.5 text-subtext/90">{t('modals.importOrder.skuShort')}</span>
            <span className="font-mono tabular-nums break-all">{item.sku}</span>
          </p>
        ) : null}
      </div>
      <Badge
        variant="secondary"
        className="shrink-0 tabular-nums px-2.5 py-1 text-xs"
        title={t('modals.importOrder.quantityTitle')}
      >
        {quantity}
      </Badge>
    </div>
  );
};
